// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import axios from 'axios'
import moment from 'moment'
import Home from './components/Home'
import Posts from './components/Posts'
import Photos from './components/Photos'
import Contact from './components/Contact'
import Admin from './components/Admin'
import AdminPosts from './components/AdminPosts.vue'
import AdminPhotos from './components/AdminPhotos.vue'
import bootstrap from 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'

// set up env variables
require('dotenv').config()

// change this to use config file

const baseURL = 'http://localhost:3000/api'

Vue.config.productionTip = false

Vue.use(VueRouter)

//  define your routes
const routes = [
  { path: '/', component: Home },
  { path: '/posts', component: Posts },
  { path: '/photos', component: Photos },
  { path: '/contact', component: Contact },
  {
    path: '/admin',
    component: Admin,
    children: [
      {
        path: 'posts',
        component: AdminPosts
      },
      {
        path: 'photos',
        component: AdminPhotos
      }
    ]}
]

var instance = axios.create({
  baseURL
});

Vue.prototype.$http = instance

Vue.prototype.$time = moment

//  Create the router instance and pass the `routes` option
//  You can pass in additional options here, but let's
//  keep it simple for now.
const router = new VueRouter({
  routes, // short for routes: routes
  mode: 'history'
})

//  instatinat the vue instance
window.vueApp = new Vue({
//  define the selector for the root component
  el: '#app',
  //  pass the template to the root component
  template: '<App/>',
  //  declare components that the root component can access
  components: {
    App
  },
  //  pass in the router to the Vue instance
  router
}).$mount('#app')//  mount the router on the app



// WEBPACK FOOTER //
// ./src/main.js